import { AppConstants } from '@ltvco/refresh-lib/ctx';
import { Stack, Text, Radio } from '@ltvco/refresh-lib/theme';
import { useContext } from 'react';

import { PLAN_DISPLAY } from '../../constants';
import { SectionCard } from '../components';

import { OfferCard } from './components';

interface TrialOfferProps {
  isSelected: boolean;
  onSelect: () => void;
}

export const TrialOffer = ({ isSelected, onSelect }: TrialOfferProps) => {
  const { images } = useContext(AppConstants);
  const extendedImages = images as any;

  return (
    <SectionCard sx={{ mt: 3, p: { xs: 2, md: 3 } }}>
      <OfferCard sx={{ py: 2.5, px: 1.25 }}>
        <Stack
          direction="row"
          alignItems="center"
          width={{ xs: 'auto', md: '100%' }}
        >
          <Radio
            checked={isSelected}
            onChange={onSelect}
            color="success"
            sx={{ p: 0, pr: 1.5 }}
          />
          <Stack
            direction={{ xs: 'column', md: 'row' }}
            textAlign="center"
            alignItems="center"
            width={{ xs: 'auto', md: '100%' }}
          >
            <img
              src={extendedImages.subscribePage.planIcon}
              alt="Trial Icon"
              height={60}
            />
            <Stack
              direction={{ xs: 'column', md: 'row' }}
              alignItems="center"
              justifyContent="space-between"
              width={{ xs: 'auto', md: '100%' }}
            >
              <Stack
                direction="column"
                alignItems={{ xs: 'center', md: 'flex-start' }}
                justifyContent="center"
                ml={{ xs: 0, md: 1 }}
              >
                <Text variant="h4" mb={0}>
                  {PLAN_DISPLAY.trialPeriod} DAY MEMBERSHIP TRIAL
                </Text>
                <Text variant="body1" mb={0}>
                  Run {PLAN_DISPLAY.monthlyLimit} reports per month!
                </Text>
              </Stack>
              <Stack alignItems="center">
                <Text
                  variant="h4"
                  fontWeight={700}
                  mt={{ xs: 1, md: 0 }}
                  mb={{ xs: 0.5, md: 0 }}
                  mr={{ xs: 0, md: 2 }}
                >
                  {PLAN_DISPLAY.setupPrice}*
                </Text>
              </Stack>
            </Stack>
          </Stack>
        </Stack>
      </OfferCard>
    </SectionCard>
  );
};
